import { render, staticRenderFns } from "./lecturer-drawer.vue?vue&type=template&id=4b8c8cdc&"
import script from "./lecturer-drawer.vue?vue&type=script&lang=js&"
export * from "./lecturer-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports